/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { QnaMakerQnaSwagger } from 'src/qnaMaker/core/services/qnas/QnaMakerAssetsSwaggers';
import { QnaMakerRowMetricStore } from 'src/qnaMaker/core/stores/QnaMakerRowMetricStore';

export const qnaJsonToQnaRowMetricStore = (qnas: QnaMakerQnaSwagger[]): QnaMakerRowMetricStore[] =>
    qnas.map(qna => new QnaMakerRowMetricStore(qna.id));
